function resolveDiscoveryPacks(totalPacks, discoveryVariants, discoveryAvailability) {
  const denominations = [
    { packs: 4, key: '48' },
    { packs: 2, key: '24' },
    { packs: 1, key: '12' }
  ].filter(d => discoveryAvailability[d.key] === true);

  let remaining = totalPacks;
  const result = [];
  for (const d of denominations) {
    const count = Math.floor(remaining / d.packs);
    if (count > 0) {
      result.push({ id: parseInt(discoveryVariants[d.key], 10), quantity: count });
      remaining -= count * d.packs;
    }
  }
  if (remaining > 0 && denominations.length > 0) {
    const smallest = denominations[denominations.length - 1];
    const existing = result.find(r => r.id === parseInt(discoveryVariants[smallest.key], 10));
    if (existing) existing.quantity += 1;
    else result.push({ id: parseInt(discoveryVariants[smallest.key], 10), quantity: 1 });
  }
  return result;
}

class BundleBuilderGrid {
  constructor(rootEl) {
    this.root = rootEl;
    this.state = {};
  }

  init() {
    this.root.addEventListener('click', (e) => this.handleClick(e));
    document.addEventListener('bundle:cart-loaded', () => this.dispatchUpdate());
    this.dispatchUpdate();

    this.root.querySelectorAll('.flavour-card').forEach(card => {
      const variantId = card.dataset.variantId;
      if (variantId) this.updateUI(variantId);
    });
  }

  handleClick(e) {
    e.preventDefault();
    const btn = e.target.closest('[data-action]');
    if (!btn) return;

    const card = btn.closest('.flavour-card');
    if (!card) return;

    if (card.classList.contains('flavour-card--out-of-stock')) return;

    const variantId = card.dataset.variantId;
    if (!variantId) return;

    const current = this.state[variantId] || 0;

    let step = 1;
    if (card.dataset.cardType === 'discovery') {
      const avail = JSON.parse(card.dataset.discoveryAvailability || '{}');
      if (avail['12'] === true) step = 1;
      else if (avail['24'] === true) step = 2;
      else if (avail['48'] === true) step = 4;
      else step = 0;
    }

    if (btn.dataset.action === 'increment') {
      this.state[variantId] = current + step;
    } else if (btn.dataset.action === 'decrement') {
      this.state[variantId] = Math.max(0, current - step);
    }

    this.updateUI(variantId);
    this.dispatchUpdate();
  }

  updateUI(variantId) {
    const card = this.root.querySelector(`.flavour-card[data-variant-id="${variantId}"]`);
    if (!card) return;

    const qty = this.state[variantId] || 0;
    const qtyEl = card.querySelector('.flavour-card__quantity');
    if (qtyEl) {
      const labels = window.buddyTranslations?.bundle?.packLabels || { singular: 'pack', plural: 'packs' };
      qtyEl.textContent = qty + ' ' + (qty <= 1 ? labels.singular : labels.plural);
    }

    const decrementBtn = card.querySelector('[data-action="decrement"]');
    if (decrementBtn) decrementBtn.classList.toggle('is-disabled', qty === 0);
  }

  dispatchUpdate() {
    const items = [];
    let totalCents = 0;

    this.root.querySelectorAll('.flavour-card').forEach(card => {
      const variantId = card.dataset.variantId;
      const priceCents = parseInt(card.dataset.variantPriceCents, 10) || 0;
      const quantity = this.state[variantId] || 0;

      items.push({ variantId, quantity, price: priceCents });
      totalCents += quantity * priceCents;
    });

    document.dispatchEvent(new CustomEvent('bundle:items-updated', {
      detail: {
        items,
        totalCents,
        totalCombinedCents: totalCents + (window.BundleState?.cartSubtotalCents || 0)
      }
    }));
  }
}

function initAllGrids() {
  document.querySelectorAll('.flavour-grid').forEach(el => {
    if (!el.dataset.bundleGridInitialized) {
      new BundleBuilderGrid(el).init();
      el.dataset.bundleGridInitialized = 'true';
    }
  });
}

document.addEventListener('DOMContentLoaded', initAllGrids);
document.addEventListener('product:rendered', initAllGrids);
